import { can, PortalPermissions } from "../../../../../config/permissions";
import { LiveTableProps } from "../../types";
import React, { useState } from "react";
import LoadingOverlay from "../../../../../components/LoadingOverlay";
import { TableContainer } from "../../styles";
import Table, { TableColumn } from "../../../../../components/Table";
import { formatBrandCodeView, formatDateView, formatMoneyCentsView, formatDocument, formatReceiverTypeCodeView } from "../../../../../utils/formatViews";
import SlcPaymentService from "../../service/paymentsService";
import { DownloadOutlined } from "@ant-design/icons";

export const LiveTable: React.FC<LiveTableProps> = ({
  data,
  currentPage,
  pageSize,
  onPageChange,
  onPageSizeChange,
 }) => {
  const paymentService = new SlcPaymentService();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const formatPaymentStatus = (status: boolean) => {
    if (status == undefined || status == null) {
      return "";
    }

    if (status === false) {
      return "Falha";
    }
    else if (status === true) {
      return "Sucesso";
    }
  }

 const downloadPdf = async (id: number) => {
  try {
    setIsLoading(true);

    const response = await paymentService.getDepositPdf(id);

    const blob = new Blob([response], { type: "application/pdf" });
    const objectUrl = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = objectUrl;
    a.download = "Declaracao_de_Transacao.pdf";

    document.body.appendChild(a);
    a.click();

    window.URL.revokeObjectURL(objectUrl);
    document.body.removeChild(a);

  } catch (error) {
    console.error("Erro ao baixar PDF", error);
  } finally {
    setIsLoading(false);
  }
};

  return (
    <div>
      <LoadingOverlay
        show={isLoading}
        relative />

      <TableContainer>
        <Table
          dataSource={data.records}
          pagination={
            {
              defaultPageSize: pageSize,
              defaultCurrent: currentPage,
              current: currentPage,
              onShowSizeChange: (_, size) => {
                onPageSizeChange(size);
              },
              total: data.count,
              onChange: (pageNum) => onPageChange(pageNum),
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} de ${total} recebíveis`,
            }}
        >
          <TableColumn title="Data Recebimento" dataIndex="receiveDate" key="brand" render={formatDateView} />
          <TableColumn title="Cód. Lojista" dataIndex="merchantId" key="merchantId" />
          <TableColumn title="Arquivo" dataIndex="fileName" key="fileName" />
          <TableColumn title="Responsável" dataIndex="holderName" key="holderName" />
          <TableColumn title="Valor pago" dataIndex="paymentValue" key="paymentValue" render={formatMoneyCentsView}/>
          <TableColumn title="Valor descontado" dataIndex="discountedValue" key="discountedValue" render={formatMoneyCentsView}/>
          <TableColumn title="Identificador Pagamento" dataIndex="paymentIdentifier" key="paymentIdentifier" />
          <TableColumn title="Tipo Recebedor" dataIndex="receiverType" key="receiverType" render={formatReceiverTypeCodeView} />
          <TableColumn title="Tipo Conta" dataIndex="accountType" key="accountType" />
          <TableColumn title="Banco" dataIndex="bankCode" key="bankCode" />
          <TableColumn title="Agência" dataIndex="bankBranch" key="bankBranch" />
          <TableColumn title="Conta bancária" dataIndex="bankAccount" key="bankAccount" />
          <TableColumn title="Bandeira" dataIndex="brandCode" key="brandCode" render={formatBrandCodeView} />
          <TableColumn title="Documento Cliente" dataIndex="customerDocument" key="customerDocument" render={formatDocument}/>
          <TableColumn title="Status" dataIndex="operationStatus" key="operationStatus" render={formatPaymentStatus}/>
          <TableColumn title="Número Pagamento Núclea" dataIndex="nucleaPaymentNumber" key="nucleaPaymentNumber" />
          <TableColumn title="Código Resposta" dataIndex="responseCode" key="merchantId" />
          <TableColumn title="Mensagem de Erro" dataIndex="errorMessage" key="errorMessage" />
          <TableColumn title="Arquivo enviado para SFTP" dataIndex="sftpEnabled" key="sftpEnabled" render={(v: boolean | null) => v == null ? "" : v ? "Sim" : "Não"} />
          <TableColumn title="Atualizado em" dataIndex="lastUpdate" key="lastUpdate" render={formatDateView} />
          <TableColumn
            title="Download"
            key="download"
            render={(_: any, deposit: any) => {
              const podeBaixar =
                deposit.operationStatus === true &&
                deposit.nucleaPaymentNumber;

              return (
                <div style={{ textAlign: "center" }}>
                  {podeBaixar && can(PortalPermissions.slc.pagamentos.baixarComprovante) && (
                    <DownloadOutlined
                      style={{ fontSize: "20px", cursor: "pointer" }}
                      onClick={() => downloadPdf(deposit.id)}
                    />
                  )}
                </div>
              );
            }}
          />
         
        </Table>
      </TableContainer>
    </div>
  )
}
